<template>
  <a-modal v-model="modal" title="新建" width="350px" :maskClosable="false" :closable="false">
    <a-form-model :model="formData" ref="form" style="margin-right: 40px">
      <a-form-model-item
        label="排名"
        :labelCol="{ style: 'width: 85px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 85px) !important;float:left'}"
        prop="rank"
        :rules="rules.rank"
      >
        <a-input-number
          style="width: 100%"
          v-model="formData.rank"
          :min="0"
          :parser="(value) => `${value}`.replace(/\D/g, '')"
          :formatter="(value) => `${value}`.replace(/\D/g, '')"
        />
      </a-form-model-item>
      <a-form-model-item
        label="得分"
        :labelCol="{ style: 'width: 85px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 85px) !important;float:left'}"
        prop="score"
        :rules="rules.score"
        v-if="['afterSalesScore', 'priceScore'].includes(currentTab)"
      >
        <a-input-number
          style="width: 100%"
          v-model="formData.score"
          :min="0"
          :max="100"
          :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
          :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
        />
      </a-form-model-item>
      <a-form-model-item
        label="分配比例"
        :labelCol="{ style: 'width: 85px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 85px) !important;float:left'}"
        prop="score"
        :rules="rules.score"
        v-if="currentTab === 'distributionRatio'"
      >
        <a-input-number
          style="width: 100%"
          v-model="formData.score"
          :min="0"
          :max="1"
          :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{4}).*$/, '$1$2.$3', '')"
          :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{4}).*$/, '$1$2.$3', '')"
        />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { apiScpMpsAppraiseConfigFd } from '@/api/finished-goods-order'

export default {
  name: 'CreateConfiguration',
  data() {
    return {
      modal: false,
      formData: { rank: null, score: null },
      loading: false,
      rules: {
        rank: [{ required: true, message: ' ', trigger: 'blur' }],
        score: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      currentTab: '', // 修改字段标识
      type: '' // 区分考核配置类型
    }
  },
  methods: {
    show (currentTab, type) {
      this.currentTab = currentTab // 区分修改字段标识
      this.type = type
      this.$set(this.formData, 'rank', null)
      this.$set(this.formData, 'score', null)
      this.modal = true
    },
    // 提交
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          const params = { type: this.type, score: this.formData.score, rank: this.formData.rank }
          this.loading = true;
          apiScpMpsAppraiseConfigFd(params).then(response => {
            if (response?.code === 200) {
              this.$message.success('新增成功')
              this.modal = false
              this.$emit("finish")
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
